import React from 'react'
import { Redirect, Route, useLocation } from 'react-router-dom'
import { pages } from '../../pages/pages'
import { useAppState } from '../../store'
// PrivateRoute
import { RouteProps } from './Route.props'

const PrivateRoute: React.FC<RouteProps> = ({ children, ...props }) => {
  const location = useLocation()
  const isLogged = useAppState(state => state.auth.isLogged)
  const userLocations = useAppState(state => state.auth.userLocations)
  const path = location.pathname
  const isLocationPath = path.includes('locations')

  const handleUrlValidations = () => {
    if (isLocationPath) {
      const locationPath = path.split('locations/')
      const currentLocationId = locationPath[1].split('/settings')
      if (userLocations.length) {
        return userLocations.includes(parseInt(currentLocationId[0]))
      }
      return false
    }
    return false
  }

  const isFacilityOwner = handleUrlValidations()

  const handleAuth = () => {
    if (isLogged) {
      if (isLocationPath && !props.skipIsFacilityOwner) {
        return isFacilityOwner
      }
      return true
    }
    return false
  }

  const handleRedirect = () => {
    if (!isLogged) {
      return pages.Home.path
    }
    if (isLogged && !isFacilityOwner) {
      return pages.Profile.path
    }
  }

  return (
    <Route
      {...props}
      render={({ location }) =>
        handleAuth() ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: handleRedirect(),
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}

export default PrivateRoute
